import dayjs, { Dayjs } from "dayjs";

import { useMediaQueryMaxWidth } from "@shared/lib/hooks/use-media-query-max-width";
import {
  CourseTitleSection,
  MobileScheduleDashboard,
  SchedulePeriodDisplay,
  FlexTable,
  FlexTableCell,
  FlexTableRow,
  NoPostsText,
  ColumnConfig,
} from "@/components";
import { useCustomTranslation } from "@/utils/useCustomTranslation";

import { ScheduleResponseDto } from "@shared/generated/api/model";

interface ScheduleDashboardProps {
  schedules: ScheduleResponseDto[];
  selectedDate: Dayjs;
}

export const ScheduleDashboard = ({
  schedules,
  selectedDate,
}: ScheduleDashboardProps) => {
  const { t } = useCustomTranslation();
  const { isMobile } = useMediaQueryMaxWidth();
  const filteredSchedules: ScheduleResponseDto[] = schedules.filter(
    (schedule) => dayjs(schedule.startsAt).isSame(selectedDate, "day"),
  );

  const columns: ColumnConfig[] = [
    { label: t("class"), flex: 2 },
    { label: t("class_date_time"), flex: 3 },
  ];

  if (isMobile) {
    return (
      <MobileScheduleDashboard
        schedules={schedules}
        selectedDate={selectedDate}
      />
    );
  }

  return (
    <FlexTable
      columns={columns}
      page={1}
      totalPages={1}
      onPageChange={() => {}}
    >
      {filteredSchedules.length === 0 && (
        <NoPostsText>{t("no_registered_schedules")}</NoPostsText>
      )}
      {filteredSchedules.length > 0 &&
        filteredSchedules.map((schedule) => (
          <FlexTableRow
            key={`${schedule.id}-${schedule.cycle.id}-${schedule.sessionNumber}`}
            height={100}
          >
            <FlexTableCell flex={2}>
              <CourseTitleSection
                type={schedule.cycle.course.type}
                difficulty={schedule.cycle.course.difficulty}
                title={schedule.cycle.course.title}
                scheduleId={schedule.id}
                size="medium"
              />
            </FlexTableCell>
            <FlexTableCell flex={4}>
              <SchedulePeriodDisplay
                cycleStartsAt={schedule.cycle.startsAt}
                cycleEndsAt={schedule.cycle.endsAt}
                totalSessions={schedule.cycle.course.totalSessions}
                scheduleStartsAt={schedule.startsAt}
                scheduleEndsAt={schedule.endsAt}
                durationPerSession={schedule.cycle.course.durationPerSession}
                sessionNumber={schedule.sessionNumber}
                size="medium"
              />
            </FlexTableCell>
          </FlexTableRow>
        ))}
    </FlexTable>
  );
};
